import '../assets/fonts/modern-era-regular-web/ModernEra-Black.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-BlackItalic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-Bold.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-BoldItalic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-ExtraBold.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-ExtraBoldItalic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-Italic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-Light.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-LightItalic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-Medium.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-MediumItalic.css';
import '../assets/fonts/modern-era-regular-web/ModernEra-Regular.css';
import '../assets/fonts/neue-haas-grotesk/NeueHaasGrot.css';
import { IThemeText, IThemeTextSizes } from './interfaces';

export const textSizes: IThemeTextSizes = {
  medium: {
    sizeExtraLarge: '13pt',
    sizeLarge: '12pt',
    sizeMedium: '10.5pt',
    sizeSmall: '9pt',
    sizeExtraSmall: '8pt'
  },
  large: {
    sizeExtraLarge: '15pt',
    sizeLarge: '14pt',
    sizeMedium: '12.5pt',
    sizeSmall: '11pt',
    sizeExtraSmall: '10pt'
  }
};

export const text: IThemeText = {
  font: 'Modern Era, sans-serif',
  // Not sure why textSizes is duplicated here (?)
  ...textSizes.medium,
  lineHeight: '1.375rem',
  lineHeightSmall: '1.125rem',
  letterSpacing: '0'
};
